<template>
    <div :class="[isError ? 'mb-3' : 'mb-6']">
        <div class="font-bold text-xl"
            :class="[isError ? 'text-red-500' : 'text-black']"
            v-if="inputLbl.name"
            :data-cy="`text_collect_point_label_${inputIndex}`">
            {{inputLbl.name}}<span class="text-red-500" v-if="inputLbl.required">*</span>
        </div>
        <div class="relative">
            <input type="text"
                class="w-full border bg-white px-4 py-2.5 text-xl leading-none"
                v-model="content"
                :placeholder="placeholder"
                :maxlength="inputMaxLength"
                :data-cy="`input_collect_point_code_${inputIndex}`"
                @input="onChange()" />
            <div class="absolute top-1/2 right-4 transform -translate-y-2/4 text-xl"
                v-if="isShowRemove"
                :data-cy="`btn_collect_point_remove_${inputIndex}`"
                @click="onRemove()">
                X
            </div>
        </div>
        <div class="text-red-500 text-xl mt-1.5"
            v-if="isError"
            :data-cy="`text_collect_point_error_${inputIndex}`">
            {{getErrorMsg}}
        </div>
    </div>
</template>
<script>
// helper
import RegxHelper from "@/helper/RegxHelper.js";
import Util from "@/helper/Utility.js";
export default {
    name: 'InputCollectPoint',
    props: {
        // v-model
        inputValid:     { type: Boolean },
        inputValue:     { type: String },
        // props
        minLength:      { type: Number },
        maxLength:      { type: Number, default: 0 },
        errorInfo:      { type: Object, required: true },
        isShowError:    { type: Boolean, default: false },
        isShowRemove:   { type: Boolean, default: false },
        isSubmitted:    { type: Boolean, default: false },
        // text
        inputIndex:     { type: Number, required: true },
        inputLbl:       { type: Object, required: true }
    },
    data: function () {
        return {
            content: this.inputValue,
            inputMaxLength: null,
            placeholder: ''
        };
    },
    computed: {
        isError: function() {
            return (this.isShowError && this.isSubmitted && !this.errorInfo.isValid);
        },
        getErrorMsg: function() {
            return (this.isShowError && this.isSubmitted && !this.errorInfo.isValid) 
                ? this.errorInfo.msg
                : '';
        }
    },
    watch: {
        inputValue: function (newVal) {
            this.content = newVal;
        }
    },
    created: function () {
        this.placeholder = Util.stringFormat(this.inputLbl.placeholder, (this.inputIndex + 1));

        if (this.maxLength > 0) {
            this.inputMaxLength = this.maxLength;
        }
    },
    mounted: function () {
        this.validateInput();
    },
    methods: {
        // event
        onChange: function () {
            let result = this.content;
            result = RegxHelper.removeNotNumber(result);
            
            this.content = result;
            this.validateInput();
            this.$emit('update:inputValue', result);
        },
        onRemove: function () {
            this.$emit('onRemove', this.inputIndex)
        },
        // method
        validateInput: function () {
            if (!this.inputLbl) return;

            // set default.
            this.errorInfo.setValid(true);
            this.errorInfo.setMsg('');
            // too short
            if (this.inputLbl.too_short && this.minLength
                && this.content.length < this.minLength) {
                this.errorInfo.setValid(false);
                this.errorInfo.setMsg(this.inputLbl.too_short);
                return;
            }

            this.$emit('update:inputValid', this.errorInfo.isValid);
        }
    }
}
</script>